const versionInfo = {
  version: '1.0',
  description: 'zero-box customer initial version',
};

export default versionInfo;
